import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { PageLoader, useFetch } from "@/lib/hooks";
import { Header } from "@/components/site/Header";
import { Logo } from "@/components/site/Logo";
import { Footer, StickyBar } from "@/components/site/StickyBar";
import { ReviewForm, ReviewThanks } from "@/components/site/ReviewDialog";

export default function ReviewPage() {
  const navigate = useNavigate();
  const { data, error } = useFetch(() => api.get("/public/site"), []);
  const [done, setDone] = useState(null);
  const s = data?.settings;

  useEffect(() => {
    if (s) document.title = `Leave a review | ${s.name}`;
  }, [s]);

  if (error)
    return (
      <div className="grid min-h-screen place-items-center p-6 text-center text-zinc-300" data-testid="review-page-error">
        We couldn't load the page. Please refresh in a moment.
      </div>
    );
  if (!data) return <PageLoader />;

  return (
    <div className="min-h-screen bg-[#121214]" data-testid="review-page">
      <Header settings={s} onHome={false} />
      <main className="mx-auto max-w-xl px-4 py-10 sm:py-16">
        <Link to="/" className="font-sub inline-flex h-11 items-center gap-2 text-sm uppercase tracking-widest text-zinc-400 transition-colors hover:text-[#FFD23F]" data-testid="review-page-back-link">
          <ArrowLeft className="h-4 w-4" /> Back to {s.name}
        </Link>
        <div className="mt-6 flex flex-col items-center text-center">
          <div className="w-full max-w-[280px]"><Logo logo={s.logo} size="lg" testId="review-page-logo" /></div>
          <h1 className="font-display mt-6 text-5xl leading-none text-[#FAF7F2] sm:text-6xl" data-testid="review-page-heading">How did we do?</h1>
          <p className="mt-3 text-base text-zinc-400">A quick review really helps our small shop.</p>
        </div>
        <div className="mt-8 rounded-lg border border-zinc-800 bg-[#1A1A1E] p-5 sm:p-7" data-testid="review-page-card">
          {done ? (
            <div className="space-y-5">
              <ReviewThanks message={done} />
              <Link to="/" className="btn-gold h-14 w-full text-lg" data-testid="review-page-see-work-button">
                See our work <ArrowRight className="h-5 w-5" />
              </Link>
            </div>
          ) : (
            <ReviewForm onDone={(d) => setDone(d.message)} />
          )}
        </div>
      </main>
      <Footer settings={s} />
      <StickyBar phone={s.primary_phone} onMessage={() => navigate("/#message")} />
    </div>
  );
}
